import { render, staticRenderFns } from "./base-performance-detail.vue?vue&type=template&id=b334f832&scoped=true"
import script from "./base-performance-detail.vue?vue&type=script&lang=ts"
export * from "./base-performance-detail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b334f832",
  null
  
)

export default component.exports